var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHash = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 66,
  viewBox: "0 0 66 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33 65C50.6731 65 65 50.6731 65 33C65 15.3269 50.6731 1 33 1C15.3269 1 1 15.3269 1 33C1 50.6731 15.3269 65 33 65Z",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.0091 31.0319L48 24.6241H43.3759L44.1025 20H37.6948L36.9681 24.6241H32.6082L33.3349 20H26.861L26.2005 24.6241H21.5763L20.5854 31.0319H25.2096L24.549 35.3918H19.9248L19 41.7995H23.6241L22.8975 46.4237H29.3052L30.0319 41.7995H34.3918L33.6651 46.4237H40.0729L40.7995 41.7995H45.4237L46.4146 35.3918H41.7904L42.451 31.0319H47.0091ZM35.3166 35.3918H30.9567L31.6173 31.0319H35.9772L35.3166 35.3918Z",
  fill: "#845EC2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hash.e75a293444012d40000ec4ea301db8ba.svg";